var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002A60;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,59.9C0,26.5,26.6,0,60.2,0c32.7,0,59.7,27.1,59.7,60.1C120,92.8,92.8,120,60,120C26.7,120,0,93.3,0,59.9z  M59,29c-4.5,0-9,0-13.5,0c-10.5,0-18,7-18.3,17.6c-0.3,9.3-0.3,18.7,0,28c0.2,10.1,7.4,17.4,17.2,17.7s19.7,0.3,29.5-0.1 c9.9-0.3,16.9-7.8,17.1-17.8c0.2-9.3,0.2-18.7,0-28C90.7,36.3,83,29,73,29C68.3,29,63.6,29,59,29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,29c4.7,0,9.3,0,14,0c10.1,0.1,17.7,7.4,18,17.5c0.2,9.3,0.2,18.7,0,28c-0.2,10-7.2,17.4-17.1,17.8 c-9.8,0.3-19.7,0.3-29.5,0.1c-9.9-0.3-17-7.6-17.2-17.7c-0.2-9.3-0.2-18.7,0-28C27.5,36,35,29,45.5,29C50,29,54.5,29,59,29z  M59,86.2L59,86.2c4.5,0,9,0,13.5-0.1c7.6-0.2,12.2-4.5,12.4-12c0.2-9,0.2-18,0-27C84.7,39.9,79.6,35,72.4,35c-8.8,0-17.7,0-26.5,0 c-7.4,0-12.3,4.5-12.6,11.9c-0.3,9.2-0.3,18.3,0,27.5c0.2,7.2,5,11.6,12.2,11.8C50,86.3,54.5,86.2,59,86.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,86.2c-4.5,0-9,0.1-13.5,0c-7.2-0.2-11.9-4.5-12.2-11.8C33,65.3,33,56.1,33.3,47c0.3-7.5,5.2-11.9,12.6-11.9 c8.8-0.1,17.7-0.1,26.5,0c7.2,0,12.3,4.9,12.5,12.1c0.2,9,0.2,18,0,27c-0.2,7.6-4.8,11.8-12.4,12C68,86.3,63.5,86.2,59,86.2L59,86.2 z M60.4,77c9.2,0.1,16.6-7.2,16.7-16.3c0.1-8.9-7.5-16.6-16.3-16.8c-8.8,0-16.7,7.7-16.8,16.5C43.9,69.3,51.4,77,60.4,77z  M78.1,39.3c-0.6,0-1.3,0.1-1.9,0.1c-0.8,1.5-2.4,3.2-2.1,4.4c0.3,1.4,2.4,2.4,3.7,3.6c1.1-1.3,3.1-2.6,3.2-4 C81,42.1,79.1,40.7,78.1,39.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,77c-9-0.1-16.5-7.7-16.4-16.6c0.1-8.8,8-16.6,16.7-16.4c8.8,0.1,16.4,7.9,16.3,16.8 C76.9,69.8,69.5,77.1,60.4,77z M71,60.4C71,54.5,66.4,50,60.6,50c-6,0-10.6,4.6-10.6,10.8c0.1,5.9,4.5,10.3,10.5,10.3 C66.7,71.1,71.1,66.7,71,60.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.1,39.3c1,1.4,2.9,2.8,2.8,4.1c-0.1,1.4-2,2.7-3.2,4c-1.3-1.2-3.3-2.2-3.7-3.6c-0.3-1.2,1.3-2.9,2.1-4.4 C76.8,39.4,77.5,39.3,78.1,39.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,60.4c0.1,6.3-4.3,10.7-10.5,10.7c-5.9,0-10.4-4.4-10.5-10.3C49.9,54.6,54.5,50,60.6,50 C66.4,50,71,54.5,71,60.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5972e0975e8e0be3ff815f4877047ac3.svg";
export { ForwardRef as ReactComponent };